module.exports = __webpack_public_path__ + "static/media/MSC.c8778775.png";